<form [formGroup]="addressForm" class="sectionBlock">
  <div class="row">
    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="form-group">
        <div class="d-flex">
          <div class="mb-3"><strong>Current Address</strong></div>
          <img src="../../../assets/images/groupHome.svg" class="pl-2 pb-3" (click)="openModal(1)">
        </div>
        <input type="text" class="form-control" placeholder="Current Address" formControlName="address">
        <div *ngIf="Submitted && f['address'].errors" style="color: red; font-size: 12px;">Current Address is
          Reqiured
        </div>
      </div>
    </div>
    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="form-group">
        <div class="d-flex">
          <div class="mb-3"><strong>Permanant Address</strong>
            <span *ngIf="showAddressIcon==true" (click)="openModal(2)"><img src="../../../assets/images/groupHome.svg"
                class="pl-2 pb-1"></span>
            <span *ngIf="isAddressDetailDialogOpen==true">
              <input class="ml-2" type="checkbox" (change)="setPermanantAddressAsCurrent($event)"> (Same as Current
              Address)</span>
          </div>
        </div>
        <input type="text" class="form-control" placeholder="Permanant Address" formControlName="permanentAddress">
        <div *ngIf="Submitted && f['permanentAddress'].errors" style="color: red; font-size: 12px;">Permanant
          Address is Reqiured</div>
      </div>
    </div>
    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="form-group">
        <div class="d-flex">
          <div class="mb-3"><strong>OfficeAddress</strong></div>
          <img src="../../../assets/images/groupHome.svg" class="pl-2 pb-3" (click)="openModal(3)">
        </div>
        <input type="text" class="form-control" placeholder="Office Address" formControlName="officeAddress">

      </div>
    </div>
    <div class="col-sm-12">
      <button type="submit" class="btn btn-success mr-2" [disabled]="!modifiedAddresses || !modifiedAddresses.length"
        *ngIf="showSubmitButton" (click)="onSubmit()">Submit</button>
    </div>
  </div>
</form>
<p-dialog [(visible)]="showAdressModal" [modal]="true" [draggable]="false" [resizable]="false" [blockScroll]=false
  [style]="{ width: '30rem' }">
  <p-header>
    {{addressToAndFromAddressDetail?.addressLabel}} Address
  </p-header>
  <app-address-detail [context]="'allotmentContext'" [adressMetaData]="addressToAndFromAddressDetail"
    (closeModal)="close($event)"></app-address-detail>
</p-dialog>